import React from 'react';
import { InstagramIcon, FacebookIcon, TwitterIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[var(--color-black-rich)] border-t border-[var(--color-gray-dark)] py-16 px-6" data-id="element-143">
      <div className="max-w-7xl mx-auto" data-id="element-144">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-145">
          {/* Brand */}
          <div data-id="element-146">
            <h3 className="text-3xl font-bold text-[var(--color-gold)] mb-4" data-id="element-147">
              Prestige Motors
            </h3>
            <p className="text-gray-400 font-light leading-relaxed" data-id="element-148">
              Curating the world's finest automobiles since 1985. Where
              excellence meets distinction.
            </p>
          </div>

          {/* Contact */}
          <div data-id="element-149">
            <h4 className="text-xl font-semibold text-white mb-4" data-id="element-150">Contact</h4>
            <ul className="space-y-3" role="list" data-id="element-151">
              <li className="flex items-start gap-3 text-gray-400" data-id="element-152">
                <MapPinIcon className="w-5 h-5 text-[var(--color-gold)] mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-153" />
                <span data-id="element-154">Jordan Zarqa Free Zone</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400" data-id="element-155">
                <PhoneIcon className="w-5 h-5 text-[var(--color-gold)] flex-shrink-0" aria-hidden="true" data-id="element-156" />
                <a href="tel:+13105551234" className="hover:text-[var(--color-gold)] transition-colors" data-id="element-157">
                  +1 (310) 555-1234
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400" data-id="element-158">
                <MailIcon className="w-5 h-5 text-[var(--color-gold)] flex-shrink-0" aria-hidden="true" data-id="element-159" />
                <a href="mailto:concierge@prestigemotors.com" className="hover:text-[var(--color-gold)] transition-colors" data-id="element-160">
                  concierge@romman.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours & Social */}
          <div data-id="element-161">
            <h4 className="text-xl font-semibold text-white mb-4" data-id="element-162">
              Showroom Hours
            </h4>
            <p className="text-gray-400 mb-2" data-id="element-163">
              Monday - Friday: 9:00 AM - 7:00 PM
            </p>
            <p className="text-gray-400 mb-2" data-id="element-164">Saturday: 10:00 AM - 6:00 PM</p>
            <p className="text-gray-400 mb-6" data-id="element-165">Sunday: By Appointment Only</p>

            <div className="flex gap-4" data-id="element-166">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-[var(--color-gray-dark)] text-gray-400 hover:border-[var(--color-gold)] hover:text-[var(--color-gold)] transition-all" aria-label="Follow us on Instagram" data-id="element-167">
                <InstagramIcon className="w-5 h-5" aria-hidden="true" data-id="element-168" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-[var(--color-gray-dark)] text-gray-400 hover:border-[var(--color-gold)] hover:text-[var(--color-gold)] transition-all" aria-label="Follow us on Facebook" data-id="element-169">
                <FacebookIcon className="w-5 h-5" aria-hidden="true" data-id="element-170" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-[var(--color-gray-dark)] text-gray-400 hover:border-[var(--color-gold)] hover:text-[var(--color-gold)] transition-all" aria-label="Follow us on Twitter" data-id="element-171">
                <TwitterIcon className="w-5 h-5" aria-hidden="true" data-id="element-172" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[var(--color-gray-dark)] flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-173">
          <p data-id="element-174">&copy; 2024 Prestige Motors. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-175">
            <a href="#privacy" className="hover:text-[var(--color-gold)] transition-colors" data-id="element-176">
              Privacy Policy
            </a>
            <a href="#terms" className="hover:text-[var(--color-gold)] transition-colors" data-id="element-177">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}